module.exports = __webpack_public_path__ + "static/group-16-4049d805bffd57488a981407c22ad6d9.svg";